export interface DeviceInfo {
  isMobile: boolean;
  isIpad: boolean;
  isFirefox: boolean;
  isIOS: boolean;
  isAndroid: boolean;
}

export function getDeviceInfo(): DeviceInfo {
  const userAgent = navigator.userAgent;
  return {
    isMobile: /iPhone|iPad|iPod|Android/i.test(userAgent),
    isIpad: /iPad/i.test(userAgent),
    isFirefox: /Firefox/i.test(userAgent),
    isIOS: /iPhone|iPad|iPod/i.test(userAgent),
    isAndroid: /Android/i.test(userAgent)
  };
}
